const Report = () =>
  import(
    /* webpackChunkName: "user-customers" */ '@/pages/user/customer/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "user-customers" */ '@/pages/user/customer/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "user-customers" */ '@/pages/user/customer/edit.vue'
  )
const Detail = () =>
  import(
    /* webpackChunkName: "user-customers" */ '@/pages/user/customer/detail.vue'
  )
const LegalInformation = () =>
  import(
    /* webpackChunkName: "user-customers" */ '@/pages/user/customer/LegalInformation.vue'
  )

export default {
  path: 'customers',
  meta: {
    label: 'customers',
    auth: 'user',
    sectionTitle: 'shared.customers'
  },
  component: {
    name: 'UserCustomers',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'UserCustomersReport',
      path: '',
      meta: {
        title: 'nav.customersReport',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'UserCreateCustomer',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'UserEditCustomer',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    },
    {
      name: 'UserCustomerDetail',
      path: ':id',
      meta: {
        label: 'detail',
        auth: 'detail'
      },
      component: Detail,
      props: true
    },
    {
      name: 'UserCustomerLegalInformation',
      path: 'legal/:id',
      meta: {
        label: 'updateLegal',
        auth: 'update'
      },
      component: LegalInformation,
      props: true
    }
  ]
}
